import fontRegular from "./assets/suisseintl-medium.otf";
import fontMono from "./assets/SuisseIntlMono-Bold.otf";
import imgruido from "./assets/ruido_150.png";
import menun from "./assets/MCMenu2op.png"
import menub from "./assets/MCMenu2opblanco.png"

export const handler = ({ inputs, mechanic, sketch }) => {
  const { width, height, opcion_a, opcion_b, opcion_c, precio_a, precio_b, precio_c, postre, imagen, blur, color, noise, imprimir } = inputs;
  let ruido;
  let menunegro;
  let menublanco;
  let img;
  let ssmedium;
  let ssmono;

  const setStylingBase = () => {
    sketch.textFont(ssmedium);
    sketch.textSize(width/25.71);
    sketch.strokeWeight(width/360);
    if (color === "Negro") {
      sketch.fill(0);
      sketch.stroke(0);
    } else {
      sketch.fill(255);
      sketch.stroke(255);

    }
  };

  const seimprime = () => {
    if (imprimir) {
      sketch.background(255);
    }
  }

  sketch.preload = () => {
    if (imagen) {
      img = sketch.loadImage(URL.createObjectURL(imagen));
    }
    ruido = sketch.loadImage(imgruido);
    menunegro = sketch.loadImage(menun);
    menublanco = sketch.loadImage(menub);
    ssmedium = sketch.loadFont(fontRegular);
    ssmono = sketch.loadFont(fontMono);
    
  };

  sketch.setup = () => {
    sketch.createCanvas(width, height);
  };


  sketch.draw = () => {
    setStylingBase();
    sketch.image(img, 0, 0, width, height, 0, 0, img.width, img.height, sketch.COVER);
    seimprime();
    sketch.filter(sketch.BLUR, blur);
    if (noise) {
      sketch.image(ruido, 0, 0, width, height, 0, 0, ruido.width, ruido.height, sketch.COVER);
    }
    if (color === "Negro") {
      sketch.image(menunegro, 0, 0, width, height, 0, 0, menunegro.width, menunegro.height, sketch.COVER);
    } else {
      sketch.image(menublanco, 0, 0, width, height, 0, 0, menublanco.width, menublanco.height, sketch.COVER);
    }
   
    if (opcion_c){
      setStylingBase();
      sketch.line(width/18, height/2.18, width/18*17, height/2.18);
      sketch.noStroke();
      sketch.text('C | ' + opcion_c, width/18, height/2.07, width/18*11);
    }

    if (opcion_b){
      setStylingBase();
      sketch.line(width/18, height/2.77, width/18*17, height/2.77);
      sketch.noStroke();
      sketch.text('B | ' + opcion_b, width/18, height/2.58, width/18*11);
    }

    sketch.noStroke();
    sketch.text('A | ' + opcion_a, width/18, height/3.48, width/18*11);
   

    sketch.text(postre, width/18, height/1.50, width/18*11);
    
    sketch.textFont(ssmono)
    sketch.text(precio_a, width/18*13.8, height/3.48);
    sketch.text(precio_b, width/18*13.8, height/2.58);
    sketch.text(precio_c, width/18*13.8, height/2.07);

  mechanic.done();
  };
};

export const inputs = {
 
  imagen: {
    type: "image"
  },
  imprimir: {
    type: "boolean",
    default: false
  },
  noise: {
    type: "boolean",
    default: true
  },
  color: {
    type:"text",
    options: ["Negro", "Blanco"],
    default: "Negro"
  },
  opcion_a: {
    type: "text",
    default: "Opción A"
  },
  precio_a: {
    type: "text",
    default: "$15.900"
  },
  opcion_b: {
    type: "text",
    default: "Opción B"
  },
  precio_b: {
    type: "text",
    default: "$14.900"
  },
  opcion_c: {
    type: "text",
    default: "Opción C"
  },
  precio_c: {
    type: "text",
    default: "$14.900"
  },
  postre: {
    type: "text",
    default: "Postre"
  },
 
  blur: {
    type: "number", 
    min: 2, 
    max: 255, 
    step: 5, 
    slider: true, 
    default: 40 
  },
  width: {
    type: "number",
    default: 1080,

  },
  height: {
    type: "number",
    default: 1920,
    editable: false

  } 
};


export const settings = {
  engine: require("@mechanic-design/engine-p5"),
  name: "Menu Maña v1.5"
};
